/**
 * BootScene.ts
 * Phaser Boot Scene for American Dream: Pocket Life.
 * Synthesizes procedural pixel art textures via PixelArtGenerator,
 * registers 4-directional chibi character animations, and launches HomeScene.
 */

import Phaser from '../engine/MicroCanvasEngine';
import { PixelArtGenerator } from '../engine/PixelArtGenerator';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  public create(): void {
    // 1. Synthesize all pixel art assets directly into Phaser's Texture Manager
    PixelArtGenerator.generateAll(this);
    PixelArtGenerator.registerCozyDioramaAssets(this);

    // 2. Register character 4-directional animations (SE, SW, NE, NW)
    this.createCharacterAnimations();

    // 3. Immediately transition to HomeScene
    this.scene.start('HomeScene');
  }

  private createCharacterAnimations(): void {
    const animConfigs: Array<{
      key: string;
      frames: number[];
      frameRate: number;
      repeat: number;
    }> = [
      // Direction 0: SE (South-East / Down-Right)
      { key: 'idle_se', frames: [0, 1], frameRate: 2, repeat: -1 },
      { key: 'walk_se', frames: [2, 3, 4, 5], frameRate: 8, repeat: -1 },

      // Direction 1: SW (South-West / Down-Left)
      { key: 'idle_sw', frames: [6, 7], frameRate: 2, repeat: -1 },
      { key: 'walk_sw', frames: [8, 9, 10, 11], frameRate: 8, repeat: -1 },

      // Direction 2: NE (North-East / Up-Right)
      { key: 'idle_ne', frames: [12, 13], frameRate: 2, repeat: -1 },
      { key: 'walk_ne', frames: [14, 15, 16, 17], frameRate: 8, repeat: -1 },

      // Direction 3: NW (North-West / Up-Left)
      { key: 'idle_nw', frames: [18, 19], frameRate: 2, repeat: -1 },
      { key: 'walk_nw', frames: [20, 21, 22, 23], frameRate: 8, repeat: -1 },
    ];

    for (const cfg of animConfigs) {
      if (!this.anims.exists(cfg.key)) {
        this.anims.create({
          key: cfg.key,
          frames: cfg.frames.map((frameNum) => ({ key: 'player_chibi', frame: frameNum })),
          frameRate: cfg.frameRate,
          repeat: cfg.repeat,
        });
      }
    }
  }
}
